import { QUERY_KEYS } from '@/queries/queryKeys'
import { notificationsService } from '@/services/api/notifications.service'
import { type NotificationSource } from '@/services/types/notifications/mockNotifications'
import { useQuery } from '@tanstack/react-query'

interface UseGetNotificationByIdProps<T extends NotificationSource = NotificationSource.reviews> {
  id: string | null
  notificationSource: T
}

async function getNotificationById<T extends NotificationSource>({ id }: { id: string | null }) {
  if (!id) return

  const response = await notificationsService.getById<T>(id)
  return response.data
}

export function useGetNotificationById<T extends NotificationSource>({
  id,
  notificationSource,
}: UseGetNotificationByIdProps<T>) {
  return useQuery({
    queryKey: [QUERY_KEYS.reviewNotifications.getAll, { id, notificationSource }],
    enabled: Boolean(id),
    queryFn: () => getNotificationById<T>({ id }),
  })
}
